import { PoiType } from "@/db/definitions";
import {
  Ambulance,
  Book,
  BookOpen,
  BusFront,
  ChefHat,
  Coffee,
  FireExtinguisher,
  Hospital,
  Martini,
  Pizza,
  Plane,
  Popcorn,
  Shield,
  ShoppingCart,
  Store,
  TrainFrontTunnel,
  TrainTrack,
  TramFront,
  TreePalm,
  University,
} from "lucide-react";
import React from "react";

type Props = {
  type: PoiType;
  className?: string;
};

export const pointOfInteretTypes = [
  "UNIVERSITY",
  "TRAIN",
  "BUS",
  "TRAM",
  "SUBWAY",
  "AIRPORT",
  "RESTAURANT",
  "CAFE",
  "FAST_FOOD",
  "BAR",
  "HOSPITAL",
  "CINEMA",
  "BEACH",
  "SUPERMARKET",
  "MARKETPLACE",
  "LIBRARY",
  "POLICE",
  "FIRE_STATION",
  "AMBULANCE_STATION",
] as const;

const IconPoi: React.FC<Props> = ({ type, className }) => {
  const iconMap: Record<PoiType, React.ReactNode> = {
    AIRPORT: <Plane className={className} />,
    AMBULANCE_STATION: <Ambulance className={className} />,
    BAR: <Martini className={className} />,
    BEACH: <TreePalm className={className} />,
    BUS: <BusFront className={className} />,
    CAFE: <Coffee className={className} />,
    CINEMA: <Popcorn className={className} />,
    FIRE_STATION: <FireExtinguisher className={className} />,
    HOSPITAL: <Hospital className={className} />,
    LIBRARY: <BookOpen className={className} />,
    MARKETPLACE: <Store className={className} />,
    POLICE: <Shield className={className} />,
    RESTAURANT: <ChefHat className={className} />,
    SUBWAY: <TrainFrontTunnel className={className} />,
    SUPERMARKET: <ShoppingCart className={className} />,
    TRAIN: <TrainTrack className={className} />,
    TRAM: <TramFront className={className} />,
    UNIVERSITY: <University className={className} />,
    FAST_FOOD: <Pizza className={className} />,
  };

  return <>{iconMap[type]}</>;
};

export default IconPoi;
